import React, { useState, useEffect } from "react";
import { Card, Input, Button, Typography, Space } from "antd";

const { Title, Text } = Typography;

function generateCaptcha(length = 3) {
  const chars = "abcdefghjkmnpqrstuvwxyz23456789"; // no confusing chars
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  // Ensure first char is capital if it's alphabet
  if (/[a-z]/.test(result[0])) {
    result = result[0].toUpperCase() + result.slice(1);
  }

  return result;
}

export default function CaptchaGate({ onSuccess }) {
  const [captcha, setCaptcha] = useState("");
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setCaptcha(generateCaptcha(3));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim() === captcha) {
      onSuccess();
    } else {
      setError("Captcha did not match. Try again.");
      setInput("");
      setCaptcha(generateCaptcha(3));
    }
  };

  const handleRefresh = () => {
    setCaptcha(generateCaptcha(3));
    setInput("");
    setError("");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
      }}
    >
      <Card
        style={{
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={3}>Verify Captcha</Title>
        <Text type="secondary">
          Please enter the text below to continue
        </Text>

        <div
          style={{
            margin: "1.5rem 0",
            fontSize: "2rem",
            fontFamily: "monospace",
            letterSpacing: "0.4rem",
            background: "#ff9fcf",
            border: "1px dashed #ff2290",
            padding: "0.5rem 1rem",
            userSelect: "none",
            // transform: "rotate(-1deg)",
          }}
        >
          {captcha}
        </div>

        <form onSubmit={handleSubmit}>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Input
              placeholder="Enter captcha"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />

            {error && <Text type="danger">{error}</Text>}

            <Space>
              <Button type="primary" htmlType="submit" style={{background:"#005cff"}}>
                Submit
              </Button>
              <Button onClick={handleRefresh}>Refresh</Button>
            </Space>
          </Space>
        </form>
      </Card>
    </div>
  );
}
